import initialState from '../initialState'

export function updateLimit(state = initialState.limit, action) {
  switch (action.type) {
    case 'SET_LIMIT':
      return action.limit
    default:
      return state
  }
}

export function updatePageNo(state = initialState.pageNo, action) {
  switch (action.type) {
    case 'SET_PAGE_NUMBER':
      return action.pageNo
    default:
      return state
  }
}

export function updateSortType(state = initialState.sortType, action) {
  switch (action.type) {
    case 'SET_SORT_TYPE':
      return action.sortType
    default:
      return state
  }
}

export function updateSortBy(state = initialState.sortBy, action) {
  switch (action.type) {
    case 'SET_SORT_BY':
      return action.sortBy
    default:
      return state
  }
}

export function updateStartDate(state = initialState.startDate, action) {
  switch (action.type) {
    case 'SET_START_DATE':
      return action.startDate
    default:
      return state
  }
}

export function updateEndDate(state = initialState.endDate, action) {
  switch (action.type) {
    case 'SET_END_DATE':
      return action.endDate
    default:
      return state
  }
}

export function updateBaseFolder(state = initialState.baseFolder, action) {
  switch (action.type) {
    case 'SET_BASE_FOLDER':
      return action.baseFolder
    default:
      return state
  }
}

export default {
  updatePageNo,
  updateLimit,
  updateSortType,
  updateSortBy,
  updateStartDate,
  updateEndDate,
  updateBaseFolder,
}
